export const EXPRESS_CHECKOUT_HEIGHTS = {
  HEADER: 105,
  ADDRESS_TILE: 54,
  WALLET_TILE: 54,
  PAYMENT_TILE: 54,
  OFFER_TILE: 52,
  DISCOUNT_BANNER: 34,
  CVV_LESS_BANNER: 24,
  PAY_BUTTON: 84,
  ERROR_SCREEN: 402,
  DELAY_SCREEN: 376
};
